import React from 'react';
import wrapDisplayName from 'recompose/wrapDisplayName';
export default (function (_ref) {
  var name = _ref.name,
      useInstead = _ref.useInstead,
      removalDate = _ref.removalDate,
      readMore = _ref.readMore;
  return function (Target) {
    var DeprecationWarning = function DeprecationWarning(props) {
      var _process, _process$env, _console, _process2, _process2$env;

      if ((_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.NODE_ENV && process.env.NODE_ENV !== 'production' && (_console = console) !== null && _console !== void 0 && _console.warn && ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.DISABLE_DEPRECATION_WARNINGS) !== 'yes') {
        var deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: '".concat(name, "' is deprecated and will be removed");

        if (removalDate) {
          deprecationWarning += " in/by ".concat(removalDate);
        }

        deprecationWarning += ".";

        if (useInstead) {
          deprecationWarning += "\nUse '".concat(useInstead, "' instead.");
        }

        if (readMore) {
          deprecationWarning += "\nRead more on ".concat(readMore);
        }

        console.warn(deprecationWarning);
      }

      return /*#__PURE__*/React.createElement(Target, props);
    };

    DeprecationWarning.displayName = wrapDisplayName(Target, 'withDeprecationWarning');
    return DeprecationWarning;
  };
});
//# sourceMappingURL=index.js.map